export const CHANGE_PROJECT_DATA = 'CHANGE_PROJECT_DATA';
export type CHANGE_PROJECT_DATA = typeof CHANGE_PROJECT_DATA;


// WEBPACK FOOTER //
// ./src/actions/project/change-data/Types.tsx